<template>
  <el-dialog
    title="グループの編集"
    :visible.sync="isOpenEditModal"
    width="50%"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :before-close="onCloseModal"
  >
    <el-form
      ref="editForm"
      :model="organization"
      label-width="30%"
      :rules="rules"
      @submit.prevent.native="onSubmit"
    >
      <div>
        <ErrorMessage :messages="errorMessages" @close="errorMessages = null"/>
      </div>
      <el-form-item label="アカウント名" prop="name">
        <el-input name="name" v-model="organization.name"></el-input>
      </el-form-item>
      <el-form-item label="アカウントID" prop="contact_email" >
        <el-input name="contact_email" v-model="organization.contact_email" disabled></el-input>
      </el-form-item>
      <el-form-item label="有効期限" prop="expired_at">
        <el-date-picker
            v-model="organization.expired_at"
            type="date"
            placeholder="Pick a day"
            style="width: 100%;"
            :picker-options="datePickerOptions"
            value-format="yyyy-MM-dd"
            v-on="$listeners"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="アカウント個数制限" prop="amount_limit" :error="errorData">
        <el-input-number
          ref="numberAmount"
          name="max_user_account"
          class="max-user-account"
          type="text"
          maxlength="6"
          :min="1"
          :max="99"
          v-model="organization.amount_limit"
        />
      </el-form-item>
      <el-form-item label="機能権限" prop="engine_ids">
        <el-checkbox-group name="path" v-model="organization.engine_ids">
          <el-checkbox v-for="item in patchCard" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="パスワード" prop="password">
        <el-input
          name="password"
          type="password"
          v-model="organization.password"
        ></el-input>
      </el-form-item>
      <div class="text-right">
        <el-button @click="onCloseModal">キャンセル</el-button>
        <el-button native-type="submit" class="btn-main" :disabled="isLoading">
          <i v-if="isLoading" class="el-icon-loading"></i>
          保存
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
  import { types } from '@/constants/organization';
  import {mapActions, mapState} from "vuex";
  import ErrorMessage from "@/components/ErrorMessage";
  import moment from "moment";
  import EngineApi from "@/api/engine.api";
  export default {
    name: 'EditOrganization',
    components: { ErrorMessage },
    data () {
      return {
        organization: {
          name: '',
          contact_email: '',
          expired_at: '',
          amount_limit: null,
          password: '',
          engine_ids: [],
          type: 1
        },
        datePickerOptions: {
          disabledDate(date) {
           return date < moment().subtract(1, 'days')
          }
        },
        errorData: "",
        patchCard: [],
        rules: {
          name: [
            { required: true, trigger: "blur", message: 'アカウント名を入力してください' },
            { max: 100, trigger: "blur", message: '100 文字以下にしてください。' },
          ],
          expired_at: [
            { required: true, trigger: 'blur' , message: '有効期限を入力してください' }
          ],
          amount_limit: [
            { required: true, type:"number", trigger: 'blur', message: 'アカウント個数制限を入力してください' },
            // { max: 999999, trigger: 'blur', message: '6 文字以下にしてください。' },
          ],
          engine_ids: [
            { type: 'array', required: true, trigger: 'blur', message: '機能権限を入力してください' }
          ],
          password: [
            { min: 8, max: 20, trigger: 'blur', message: 'パスワードは８文字以上、２０文字以内で入力してください。' }
          ],
          contact_email: [
            {required: true, trigger: 'blur', message: 'アカウントIDを入力してください',},
            // {
            //   validator: (rule, value, callback) => {
            //     if (!validEmail(value)) {
            //       callback(new Error('有効なメールアドレスを入力してください。'));
            //     } else {
            //       callback();
            //     }
            //   },
            //   trigger: 'blur'
            // },
            { max: 100, trigger: "blur", message: '100 文字以下にしてください。' },
          ],
        },
        isLoading: false,
        errorMessages: null
      }
    },
    props: {
      isOpenEditModal: {
        default: false
      },
      organizationId: {
        default: null
      }
    },
    computed: {
      ...mapState({
        organizationState: state => state.admin_organizations.organization,
      }),
      typeList () {
        return types;
      }
    },
    methods: {
      ...mapActions('admin_organizations', ['getDetail', 'update']),
      onCloseModal () {
        this.$emit('close');
        this.$refs.editForm.resetFields()
        return true;
      },
        handlePaste() {
            console.log("aaaaaaaaaa")
            return false;
        },
      handleNumber(event) {
        if (this.inputValue !== null && this.inputValue instanceof String) {
          this.inputValue = this.inputValue.toString().replace(/[^\d].+/, '')
        }
        this.$refs.numberAmount.value = this.$refs.numberAmount.value.toString().replace(/[^\d].+/, '')
        if ((event.which < 48 || event.which > 57)) {
          event.preventDefault()
        }
      },
      async getListEngine() {
        await EngineApi.getEngineList().then((res) => {
          this.patchCard = res.data
        })
      },
      async initData () {
        this.getListEngine()
        await this.getDetail({ id: this.organizationId });
        if (this.organizationState) {
            this.organization.name = this.organizationState.name,
            this.organization.contact_email = this.organizationState.contact_email,
            this.organization.type = this.organizationState.type,
            this.organization.expired_at = this.getDate(this.organizationState.expired_at)
            this.organization.amount_limit = Number(this.organizationState.amount_limit),
            this.organization.engine_ids = this.getEngineIds(this.organizationState.engine_list),
            this.organization.password = ''
        }
        this.errorMessages = null;
      },
      getDate(date) {
        if (!date) return
        return moment(date).format('YYYY-MM-DD')
      },
      getEngineIds(data) {
        const arr = []
        for (const item of data) {
          if (item.id) {
            arr.push(item.id)
          }
        }
        return arr
      },
      async onSubmit () {
        if (this.isLoading) return false;
        this.errorMessages = null;
        this.$refs.editForm.validate(async (isValid) => {
          if (!isValid) return false;
          this.isLoading = true;
          this.organization.id = this.organizationId;
          let res = await this.update(this.organization);
          this.isLoading = false;
          if (!res.success) {
              this.errorMessages = res.data;
               return false;
          } else {
              this.$emit('onOrganizationUpdated');
          }
        });
      },
    },
    watch: {
      isOpenEditModal (newVal, oldVal) {
        if (newVal && (newVal !== oldVal)) this.initData();
      }
    }
  }
</script>

<style scoped>
/deep/.max-user-account .el-input > .el-input__inner {
    padding-left: 15px;
    padding-right: 15px;
    text-align: left;
}
/deep/.max-user-account {
    width: 100%;
}
/deep/.max-user-account > .el-input-number__decrease, /deep/.max-user-account > .el-input-number__increase {
    display: none !important;
}
</style>
